import { css } from "emotion";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import P from "../../../components/global/P";
import Banner from "../../../components/layout/Banner";
import Layout from "../../../components/layout/Layout";
import { updateTitle } from "../../../utils/BrowserUtils";
import DescriptionBlock from "../DescriptionBlock";
import Flag from "./componets/Flag";
import HowToHelp from "./componets/HowToHelp";
import HowWeDeliver from "./componets/HowWeDeliver";
import OurImpacts from "./componets/OurImpacts";
import ProjectDeliveryPartners from "./componets/ProjectDeliveryPartners";
import Quote from "./componets/Quote";

const bannerImage = require("../../../assets/Projects/OzHarvestBanner.png");
const icTruck = require("../../../assets/Projects/ic_food_truck.svg");
const icWhisk = require("../../../assets/Projects/ic_lifelong_skills&education.svg");
const quoteImage = require("../../../assets/Projects/Ronni-Kahn.png");
const ozHarvest = require("../../../assets/Projects/OzHarvest.png");
const partnerLogo = require("../../../assets/Projects/ozHarvestLogo.png");

const bannerContent = css({
  padding: "0px 0px 0px 80px",
  textAlign: "left",
  h2: {
    maxWidth: 402,
    marginBottom: 16,
    fontSize: 36
  },
  p: {
    maxWidth: 402,
    marginBottom: 20,
    marginLeft: 0,
    fontSize: 18
  },
  "@media(max-width: 1080px)": {
    padding: "112px 0px 24px 80px"
  },
  "@media(max-width: 768px)": {
    padding: "40px 14px 24px 14px",
    h2: {
      fontSize: 22
    },
    p: {
      fontSize: 16
    }
  }
});

const impactsObj = [
  {
    title: "Every ticket counts",
    content: "$1 = 2 meals",
    subtext: "all funded from booking fees"
  },
  {
    title: "Our impact",
    content: "150,000 meals",
    subtext: "meals provided to date"
  },
  {
    title: "Our target",
    content: "10 million",
    subtext: "meals by 2030"
  }
];

const howWeDeliverNutrition = [
  {
    image: icTruck,
    alt: "Food truck icon",
    title: "Food Rescue and Delivery",
    content:
      "Food that would otherwise go to waste is rescued and delivered to local support charities, such as shelters for families. Our delivery partners span 1300 local charities."
  },
  {
    image: icWhisk,
    alt: "Whisk icon",
    title: "Lifelong Skills and Education",
    content:
      "The FEAST (Food Education and Sustainability Training) program inspires kids to eat healthy, waste less and be change makers in their local community. This program trains the kids directly, and trains teachers to expand the reach."
  }
];

const OzHarvest = ({ localeData }) => {
  updateTitle("OzHarvest");
  // const consoleUrl =
  //   localeData && localeData.consoleURL ? localeData.consoleURL : "";

  const explanation = [
    "Yet every year, one million children in Australia experience food insecurity, relying on shelters and charities for their next meal.",
    "Children who go to school hungry have difficulties concentrating in class, experience learning difficulties and are more likely to miss school frequently. Teachers estimate that the average student loses more than 2 hours a day of learning time when they come to school hungry.",
    "This can all lead to long-term effects on their life outcomes and impacts their ability to reach their full potential both in and out of the classroom."
  ];

  return (
    <Layout>
      <Banner image={bannerImage} bgColor="greyBackground">
        <div className={bannerContent}>
          <H2 marginBottom={16} marginBottomMobile={12}>
            Nutrition for School Kids
          </H2>
          <P>
            Every day in Australia, one child in every classroom goes to school
            hungry. So we’re equipping kids with the ingredients and the skills
            for healthy bodies and minds.
          </P>
        </div>
      </Banner>

      <OurImpacts data={impactsObj} />

      <DescriptionBlock
        heading="No child can be expected to learn on an empty stomach"
        alt="Kids smiling whilst cooking in ozHarvest"
        image={ozHarvest}
        text={explanation}
      />

      <HowWeDeliver
        header="How we deliver our nutrition program"
        data={howWeDeliverNutrition}
      />

      <HowToHelp
        localeData={localeData}
        text="We’re a unique charity, in that we don’t ask for donations (though you are welcome to offer). "
      />

      <ProjectDeliveryPartners>
        <P>
          We believe in impact with evidence, not just good intentions. That’s
          why we work with expert delivery partners, to make sure all our
          projects are making long lasting, systemic change.
        </P>
        <Flag>
          <img src={partnerLogo} alt="OzHarvest Logo" />
          <P>
            Our nutrition for school kids work is delivered in partnership with
            Ozharvest’s network of 3,500 food donors and 1,300 local charities.
          </P>
        </Flag>
        <Quote
          image={quoteImage}
          imageAlt="Picture of Ronni Kahn AO."
          quote="“Whilst food rescue fills hungry bellies, education transforms lives and is the key to influencing change.” "
          author="Ronni Kahn AO, OzHarvest Founder and CEO"
        />
      </ProjectDeliveryPartners>
    </Layout>
  );
};

export default CMSComponent(null, OzHarvest);
